import React from "react";
import {memo} from "react";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";

/**
 * `withRouter` HOC wrapper to replace react-router
 *
 * @param {ReactComponent} Component Component to wrap
 * @return {ReactComponent} Wrapped component with authentication details
 */
const withRouter = Component => {

	return memo(props => {

		const location = useLocation();
		const navigate = useNavigate();
		const params = useParams();
		const [searchParams, setSearchParams] = useSearchParams();

		return (
			<Component
				{...props}
				location={location}
				navigate={navigate}
				params={params}
				searchParams={searchParams}
				setSearchParams={setSearchParams} />
		);

	});

};

export default withRouter;
